import { render, staticRenderFns } from "./employee_addoredit.vue?vue&type=template&id=3295cc4a&"
import script from "./employee_addoredit.vue?vue&type=script&lang=js&"
export * from "./employee_addoredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports